<template>
  <lego-modal ref="modal" :title="$t('page.dashboard.deleteWidget')" :size="460" @closed="pageOnCLosed">
    <div class="textContainer">
      {{ $t('page.dashboard.confirmDeleteWidget') }}
    </div>

    <!-- 하단버튼 -->
    <template #action>
      <lego-button medium @click="pageOnCLosed">{{ $t('button.cancel') }}</lego-button>
      <lego-button medium main @click="onConfirm">{{ $t('button.confirm') }}</lego-button>
    </template>
  </lego-modal>
</template>
<script>
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  props: ['params'],
  mixins: [i18nMixin],
  emits: ['deleteWidget', 'close'],
  mounted() {
    this.$refs['modal'].open();
  },
  methods: {
    /*************
     * page
     *************/
    pageOnCLosed() {
      this.$emit('close');
    },
    onConfirm() {
      this.$emit('deleteWidget');
      this.$emit('close');
    }
  }
};
</script>
<style lang="scss" scoped>
.textContainer {
  display: flex;
  margin-top: 10px;
  width: 356px;
  height: 52px;
  margin: 0px 20px 0 0;
  font-family: $lego__font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
  text-align: left;
  color: var(--dark);
}
</style>
